import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import Button from "components/CustomButtons/Button.js";
import FileUpload from "components/FileUpload/FileUploadSanction";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import brandTheme from "brandTheme/Theme";
import { Button, Grid } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import SanctionLetterOld from "./SanctionLetterOld";
import SanctionLetterNew from "./SanctionLetterNew";

const SanctionLetter = ({
  setNext,
  setBack,
  loanApplicationId,
  classes,
  subStatus,
  setIsEsign,
  isEsign,
  alreadyEsigned,
  setAlreadyEsigned,
  esingDisable, 
  setEsignDisable,
  initiatorType,
  featureFlags
}) => {
  if(subStatus === ""){
    return <SanctionLetterOld
    classes={classes}
    loanApplicationId={loanApplicationId}
    setNext={setNext}
    setBack={setBack}
    setIsEsign={setIsEsign}
    isEsign={isEsign}
    alreadyEsigned={alreadyEsigned}
    setAlreadyEsigned={setAlreadyEsigned}
    featureFlags={featureFlags}
    />
  }
  return (
  <SanctionLetterNew
  classes={classes}
  loanApplicationId={loanApplicationId}
  setNext={setNext}
  setBack={setBack}
  setIsEsign={setIsEsign}
  isEsign={isEsign}
  alreadyEsigned={alreadyEsigned}
  setAlreadyEsigned={setAlreadyEsigned}
  esingDisable={esingDisable}
  setEsignDisable={setEsignDisable}
  initiatorType={initiatorType}
  featureFlags={featureFlags}
  />
  
  );
};

SanctionLetter.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
};

export default SanctionLetter;